import api from "../services/api";

export const fillContactUsForm = (data) => {
    return api.post('user/common/contactus/fill',
        { ...data },
        {
            headers: {
                'Content-Type': 'application/json',
            }
        });
}

export const getCommonContent = () => {
    return api.get(`common/common_content`, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

export const getQuestions = () => {
    return api.get(`common/questions`, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
};